import React, { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { Image as PrimeImage } from 'primereact/image';
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import { Galleria } from 'primereact/galleria';
import { DataView } from "primereact/dataview";
import { storage } from "../../helpers/storage";
const DialogDocumento = (
    {
        visible = false,
        header = "",
        onHide = () => { },
        draggable,
        data = [],
        dataBin = [],
        idUsuario,
        idUsuarioPerfil,
        stylePersonalizado = ""
    }
) => {

    const [documentos, setDocumentos] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [file, setFile] = useState('')
    const [files, setFiles] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [bandera, setBandera] = useState(false);
    const [openDialogDescargar, setOpenDialogDescargar] = useState(false)
    const toast = useRef(null);

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    useEffect(() => {
        if (data.length > 1) {
            if (data.every(objeto => [".png", ".jpg", ".jpeg"].includes(objeto.TipoArchivo))) {
                obtenerArchivo(data, data[0])
            } else {
                setDocumentos(data)
            }
        } else if (data.length === 1) {
            obtenerArchivo(data, data[0])
        }
    }, [data])

    useEffect(() => {
        console.log("loading", openDialogDescargar)
    }, [openDialogDescargar])

    const base64toBlob = (data) => {
        // console.log(data)
        try {
            if (data !== null) {
                const matches = data.match(/^data:(.+);base64,(.*)$/);

                const mimeType = matches[1]; // Extract the MIME type
                const base64 = matches[2]; // Extract the Base64 data

                const bytes = atob(encodeURI(base64))
                let lenght = new Array(bytes.length)
                for (let i = 0; i < lenght; i++) {
                    lenght[i] = bytes.charCodeAt(i)
                }
                const byteArray = new Uint8Array(lenght)
                return new Blob([byteArray], { type: mimeType })
            } else {
                return null;
            }
        } catch (err) {
            console.warn("Error: ", err)
            return null;
        }


    }

    const AbrirArchivo = (contenido) => {

        const linkSource = contenido.Archivo
        const bytes = base64toBlob(linkSource)
        if (bytes !== null) {
            if (contenido.TipoArchivo === ".pdf" && bytes.size < 1500000) {
                setFile(
                    "<iframe width='100%' height='100%' src='" + linkSource + "'></iframe>"
                )
                setOpenDialog(true);
            } else {
                toast.current.show({ severity: 'success', summary: 'Aviso', detail: 'El archivo es demasiado grande para abrirlo, se ha descargado.', life: 9000 });
                const downloadLink = document.createElement('a')
                const fileName = contenido.NombreArchivo
                downloadLink.href = linkSource
                downloadLink.download = fileName
                downloadLink.click();
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Archivo en proceso de guardado, intente más tarde.', life: 9000 });
        }
        setOpenDialogDescargar(false)
    }

    const obtenerArchivo = async (documentos, contenido) => {
        setOpenDialogDescargar(true);

        if ([".png", ".jpg", ".jpeg"].includes(contenido.TipoArchivo)) {
            setBandera(true);
            setActiveIndex(documentos.filter(x => [".png", ".jpg", ".jpeg"].includes(x.TipoArchivo)).indexOf(contenido))
            const imageItems = await Promise.all(
                documentos.filter(item => [".png", ".jpg", ".jpeg"].includes(item.TipoArchivo)).map(async (x) => {
                    return await helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                        body: {
                            "Opcion": "O",
                            "CicloEscolar": "",
                            "TipoMaquila": "",
                            "TipoArchivo": "",
                            "RutaArchivo": "",
                            "id": x.id,
                            "IdUsuario": idUsuario,
                            "NombreArchivo": "",
                            "Folio": data.idFolioMaquila,
                            "FechaCreate": new Date().toISOString(),
                            "Activo": true,
                            "Archivo": "",
                            "IdCicloEscolar": x.IdCicloEscolar,
                            "parametrosExtra": `[{"idFolio": ${x.Folio}, "idTarea": ${x.TipoMaquila}, "idTipoUsuario": ${idUsuarioPerfil}, "idTipoMaquila": "${x.idTipoMaquila}", "codigo": "${x.Codigo}"}]` //se usan estos campos como provicionales
                        },
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Accept": "application/json",
                            'Authorization': `Bearer ${storage.get('token')}`
                        }
                    }).then(async (res) => {
                        if (res.SUCCESS) {
                            const base64 = [".jpg"].includes(res.ITEMS.TipoArchivo) ? await convertJpgBase64ToJpeg(res.ITEMS.Archivo) : res.ITEMS.Archivo
                            try {
                                let item = {
                                    itemImageSrc: base64,
                                    title: res.ITEMS.NombreArchivo.toLowerCase().endsWith('.jpg') ? res.ITEMS.NombreArchivo.slice(0, -4) + '.jpeg' : res.ITEMS.NombreArchivo
                                }
                                return item;

                            } catch (err) {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    })
                })
            );

            if (imageItems.length !== 0) {
                setFiles(imageItems);
                setOpenDialog(true);
                setOpenDialogDescargar(false)
            }
        } else {
            setBandera(false);
            helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                body: {
                    "Opcion": "O",
                    "CicloEscolar": "",
                    "TipoMaquila": "",
                    "TipoArchivo": "",
                    "RutaArchivo": "",
                    "id": contenido.id,
                    "IdUsuario": idUsuario,
                    "NombreArchivo": "",
                    "Folio": data.idFolioMaquila,
                    "FechaCreate": new Date().toISOString(),
                    "Activo": true,
                    "Archivo": "",
                    "IdCicloEscolar": contenido.IdCicloEscolar,
                    "parametrosExtra": `[{"idFolio": ${contenido.Folio}, "idTarea": ${contenido.TipoMaquila}, "idTipoUsuario": ${idUsuarioPerfil}, "idTipoMaquila": "${contenido.idTipoMaquila}", "codigo": "${contenido.Codigo}"}]` //se usan estos campos como provicionales
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    AbrirArchivo(res.ITEMS)
                }
            })
        }
    }

    const convertJpgBase64ToJpeg = async (base64Jpg, quality = 0.92) => {
        return new Promise((resolve, reject) => {
            try {
                const img = new Image();

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);

                    // Convertir a JPEG y resolver la promesa
                    const jpegBase64 = canvas.toDataURL('image/jpeg', quality);
                    resolve(jpegBase64);
                };

                img.onerror = () => {
                    reject(new Error('Error al cargar la imagen'));
                };

                img.src = base64Jpg;
            } catch (error) {
                reject(error);
            }
        });
    }

    const listTemplate = (item) => {
        let indice = item.NombreArchivo.indexOf(".")
        let resultado = item.NombreArchivo.substring(0, indice)
        return (
            <div className="col-12 lg:col-3 md:col-4 p-2 text-center">

                <div style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px', borderRadius: '15px' }}>
                    <br />
                    <Tooltip target=".nombreArchivolabel" mouseTrack mouseTrackLeft={10} />
                    <i className='pi pi-image' style={{ fontSize: '40px', marginTop: '15px' }} />
                    <br />
                    <div className='nombreArchivolabel' data-pr-tooltip={item.NombreArchivo} style={{ color: 'black', fontSize: '16px', marginTop: '5px' }}>{item.NombreArchivo.substring(0, 16).toLowerCase()}..{item.TipoArchivo}</div>
                    {/* <div style={{ color: 'black', marginTop: '5px' }}>Tipo {item.TipoArchivo }</div> */}
                    {/* <div style={{ color: 'black', marginTop: '5px' }}>Ciclo {item.Descripcion}</div>
                    <div style={{ color: 'black', marginTop: '5px' }}>{new Date(item.FechaCreate.split('T').shift()).toLocaleDateString('en-GB')}</div> */}
                    <div style={{ color: 'black', fontSize: '11px', marginTop: '5px' }} />
                    <br />
                    <div className="col-12">
                        <Button className="p-button p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => obtenerArchivo(documentos, item)}>Ver</Button>
                        {/* <Button className="p-button-outlined p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => AbrirConfirmacion(item)}>Eliminar</Button> */}
                    </div>
                </div>
            </div>
        )
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex justify-content-center w-full">
                <PrimeImage
                    src={item.itemImageSrc}
                    alt={item.alt}
                    imageStyle={{ width: 'auto', maxHeight: '410px', display: 'block', maxWidth: '-webkit-fill-available' }}
                    preview
                    indicatorIcon={<i className="pi pi-search-plus"></i>} />
            </div>
        );
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.itemImageSrc} alt={item.alt} style={{ display: 'block', width: '100px', height: '100px' }} />;
    }

    const caption = (item) => {
        return (
            <React.Fragment>
                <div className="text-white">{item.title}</div>
            </React.Fragment>
        );
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={data.length > 1 ? data.every(objeto => [".png", ".jpg", ".jpeg"].includes(objeto.TipoArchivo)) ? false : visible : false} blockScroll={true} header={header} onHide={() => onHide()} draggable={Boolean(draggable)} breakpoints={{ "800px": "100%" }} style={stylePersonalizado === "" ? { width: '80%', height: '90%' } : stylePersonalizado}
                footer={
                    <div className='p-component-modal-tabla' style={{ float: 'right' }}>
                    </div>
                }
            >
                <div className="grid m-3">
                    <DataView
                        className="w-full"
                        value={documentos}
                        emptyMessage="No se encontraron resultados"
                        itemTemplate={listTemplate}
                    /* paginator
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink  NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} hasta {last} de {totalRecords}" */
                    />
                    {/* {documentos.map((x, index) => {
                        let indice = x.Mimetype.indexOf("/")
                        let resultado = x.Mimetype.substring(0, indice)
                        return (
                            <div key={index} className="col-12 xl:col-3 lg:col-4 md:col-6 sm:col-12 text-center" style={{ padding: '10px' }} >

                                <Tooltip target=".custom-target-label" />

                                <div style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px', borderRadius: '15px', height: '230px', minWidth: '207px' }}>
                                    <br />
                                    <i className='pi pi-image' style={{ fontSize: '40px', marginTop: '15px' }} />
                                    <br />
                                    <br />
                                    <div dangerouslySetInnerHTML={{ __html: x.Descripcion.toUpperCase() }} style={{ color: 'black', fontWeight: 'bold', fontSize: '16px', marginTop: '5px' }} />
                                    <div className='custom-target-label' data-pr-tooltip={x.NombreArchivo} dangerouslySetInnerHTML={{ __html: x.NombreArchivo.substring(0, 25).toLowerCase() }} style={{ color: 'black', marginTop: '5px' }} />
                                    <div dangerouslySetInnerHTML={{ __html: 'Tipo ' + x.Mimetype.toLowerCase() }} style={{ color: 'black', fontSize: '11px', marginTop: '5px' }} />
                                    <br />
                                    <Button className="p-button p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => obtenerArchivo(x)}>Ver</Button>
                                </div>
                            </div>
                        )
                    })} */}
                    <Dialog
                        header='CARGANDO DOCUMENTOS'
                        blockScroll={true}
                        visible={openDialogDescargar}
                        closable={false}
                        breakpoints={{ "800px": "100%" }}
                        style={{ width: "80%", height: "90%" }}
                        showHeader={false}
                        contentStyle={{ background: 'lightgray', opacity: '60%' }}
                        draggable={false}
                    >
                        <div className="text-center" style={{ marginTop: '200px' }}>
                            <ProgressSpinner />
                            <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>Cargando documento...</strong></div>
                        </div>
                    </Dialog>
                </div>
            </Dialog>
            <Dialog id='dialog_carrusel' visible={openDialog} blockScroll={true} header={header} onHide={() => { setOpenDialog(false); setFile(null) }} draggable={Boolean(draggable)} breakpoints={{ "800px": "100%" }} style={stylePersonalizado === "" ? { width: '80%', height: '90%' } : stylePersonalizado}
                footer={<div className='p-component-modal-tabla' style={{ float: 'right' }}></div>}>
                {
                    bandera !== true ?
                        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: file }} />
                        :
                        <Galleria value={files} responsiveOptions={responsiveOptions} numVisible={4} item={itemTemplate} thumbnail={thumbnailTemplate} caption={caption} />
                }
            </Dialog>
        </>
    )
}

export default DialogDocumento